/* eslint-disable prettier/prettier */
import './index.css';

import {
  Button,
  CircularProgress,
  FormControlLabel,
  Grid,
  Icon,
  Switch,Tooltip

} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import CalculateCommissionAffiliate from 'components/CalculateCommissionAffiliate';
import ColoredFormattedNumber from 'components/ColoredFormattedNumber';
import MyIcon from 'components/Icon';
import ModalActions from 'components/ModalActions';
import PermissionHide from 'components/PermissionHide';
import Spin from 'components/Spin';
import Truncate from 'components/Truncate';
import { functions } from 'helpers';
import { constants } from 'helpers/constants';
import { EProductStatus, PRODUCT_STATUS_LABEL } from 'helpers/enums';
import React, { Component, Fragment } from 'react';
import { FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import DraftLabel from 'scenes/Producer/Product/components/DraftLabel';
import Alumy from 'scenes/Producer/Product/components/Partners/Alumy';
import Blinket from 'scenes/Producer/Product/components/Partners/Blinket';
import {
  cloneProductById,
  getAffiliatesProductStatusSummary,
  listProductInvoice,
  productDelivery,
  productInviteAffiliate,
  productStatus,
} from 'store/Orbita/Product/actions';
import { showProduct } from 'store/Orbita/Showcase/actions';
import chatBotService, {Activity} from 'v2/services/chatBot';
import { ruleRunner, run } from 'validations/ruleRunner';
import { isEmail, required } from 'validations/rules';

import EditButton from './components/EditButton';
import QuickActions from './components/QuickActions';

import type { DispatchProp } from 'react-redux';
import type { RouteComponentProps} from 'react-router-dom';

/* eslint-disable prettier/prettier */
const fieldValidations = {
  inputInviteAffiliate: ruleRunner('inputInviteAffiliate', 'e-mail', required, isEmail)
};

interface IProps extends DispatchProp<any>, RouteComponentProps<{}> {
  active: boolean;
  changeActive: any;
  onEditProduct: any;

  productData: any;
  activatedChildren: any;
  productInvoice: any;
  affiliatesProductStatusSummary: any;
  productStatus: any;
  productInviteAffiliate: any;
  productDelivery: any;

  cloneProductById: any;
  vitrineData: any;
  user: any;
}

interface IStates {
  idProductHistory: number;

  modalStatusProduct: boolean;
  modalStatusProductArchive: boolean;
  modalCloneProduct: boolean;

  statusProduct: 'active' | 'inactive' | 'filed' | 'draft' | ' ';

  loading: boolean;
  loadingStatus: boolean;
  loadingStatusArchive: boolean;
  loadingCloneProduct: boolean;

  inputInviteAffiliate: string;
  validationErrors: object;

  inputDelivery: string;
  inputDeliveryError: boolean;

  productInvoiceData: any;
  affiliatesProductStatusSummaryData: any;
  actionButtonDisabled: boolean;

  numberAffiliates: number;
}

class QuickView extends Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      loading: true,
      idProductHistory: null,
      modalStatusProduct: false,
      modalStatusProductArchive: false,
      modalCloneProduct: false,

      statusProduct: null,

      loadingStatus: false,
      loadingStatusArchive: false,

      inputInviteAffiliate: null,

      inputDelivery: null,
      inputDeliveryError: false,

      loadingCloneProduct: false,
      productInvoiceData: null,
      affiliatesProductStatusSummaryData: null,
      actionButtonDisabled: false,

      numberAffiliates: 0,

      validationErrors: {},
    };

    this.handleCloseQuickView = this.handleCloseQuickView.bind(this);

    this.handleClickModalStatusProduct = this.handleClickModalStatusProduct.bind(this);
    this.onCancelModal = this.onCancelModal.bind(this);
    this.onConfirmModal = this.onConfirmModal.bind(this);

    this.handleClickModalStatusProductArchive = this.handleClickModalStatusProductArchive.bind(this);
    this.onConfirmModalArchive = this.onConfirmModalArchive.bind(this);
    this.onCancelModalArchive = this.onCancelModalArchive.bind(this);

    this.handleClickInviteAffiliate = this.handleClickInviteAffiliate.bind(this);
    this.handleClickDelivery = this.handleClickDelivery.bind(this);

    this.handleClickModalCloneProduct = this.handleClickModalCloneProduct.bind(this);
    this.onCancelModalCloneProduct = this.onCancelModalCloneProduct.bind(this);
    this.onConfirmModalCloneProduct = this.onConfirmModalCloneProduct.bind(this);

    this.handleClickGetInvoice = this.handleClickGetInvoice.bind(this);
    this.handleClickGetAffiliatesProductStatusSummary = this.handleClickGetAffiliatesProductStatusSummary.bind(this);
  }

  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };

  onValidation = (field: string) => {
    let validationErrors = this.state.validationErrors;
    let obj = run(this.state, [fieldValidations[field]]);

    validationErrors[field] = obj[field];

    for (let prop in validationErrors) {
      if (!validationErrors[prop]) {
        delete validationErrors[prop];
      }
    }

    this.setState({
      validationErrors
    });
  };

  // fecha o quickview
  handleCloseQuickView() {
    if (typeof this.props.changeActive === 'function') {
      this.props.changeActive();
    }

    this.setState({
      loading: true,
      idProductHistory: this.props.productData.id
    });
  }

  // abre o modal de status do produto (inativo/ativo)
  handleClickModalStatusProduct() {

    const { productData: product } = this.props;

    if (Blinket.isBlinket(product.cnt_partner_cod)) {
      Blinket.blinketModal();
      return;
    }

    this.setState({ modalStatusProduct: !this.state.modalStatusProduct });
  }

  // cancela a ação do modal de status do produto (inativo/ativo)
  onCancelModal() {
    this.handleClickModalStatusProduct();
  }

  // confirma a ação do modal de status do produto (inativo/ativo)
  onConfirmModal() {
    this.handleClickModalStatusProduct();
    this.setState({ loadingStatus: true, actionButtonDisabled: true });

    (async () => {
      try {
        await this.props.dispatch(productStatus(this.props.productData.id, this.state.statusProduct === 'active' ? EProductStatus.INACTIVE : EProductStatus.ACTIVE));

        this.setState({
          statusProduct: this.state.statusProduct === 'active' ? 'inactive' : 'active',
          loadingStatus: false,
          actionButtonDisabled: false
        });

        toast.success('Produto alterado com sucesso');

        this.props.onEditProduct();
      } catch {
        this.setState({
          loadingStatus: false,
          actionButtonDisabled: false
        });

        toast.error('Ops, erro ao atualizar o status do produto');
      }
    })();
  }

  // abre o modal de status do produto (apenas o state arquivar)
  handleClickModalStatusProductArchive() {
    const { productData: product } = this.props;

    if (Alumy.isAlumy(product.cnt_partner_cod)) {
      Alumy.alumyModal();

      return;
    }

    if (Blinket.isBlinket(product.cnt_partner_cod)) {
      Blinket.blinketModal();
      return;
    }

    this.setState({ modalStatusProductArchive: !this.state.modalStatusProductArchive });
  }

  // cancela a ação do modal de status do produto (arquivado)
  onCancelModalArchive() {
    this.handleClickModalStatusProductArchive();
  }

  // confirma a ação do modal de status do produto (arquivado)
  onConfirmModalArchive() {
    this.setState({
      loadingStatusArchive: true,
      actionButtonDisabled: true
    });

    this.handleClickModalStatusProductArchive();

    (async () => {
      try {
        await this.props.dispatch(productStatus(this.props.productData.id, EProductStatus.ARCHIVE));

        this.setState({
          statusProduct: 'filed',
          loadingStatusArchive: false,
          actionButtonDisabled: false
        });

        this.props.onEditProduct();
      } catch {
        this.setState({
          loadingStatusArchive: false,
          actionButtonDisabled: false
        });

        toast.error('Ops, não foi possível excluir o produto');
      }
    })();
  }

  // abre o modal de clonar o produto
  handleClickModalCloneProduct() {

    const { productData: product } = this.props;

    if (Blinket.isBlinket(product.cnt_partner_cod)) {
      Blinket.blinketModal();
      return;
    }

    this.setState({ modalCloneProduct: !this.state.modalCloneProduct });
  }

  // cancela a ação do modal de clonar o produto
  onCancelModalCloneProduct() {
    this.handleClickModalCloneProduct();
  }

  // confirma a ação do modal de clonar o produto
  onConfirmModalCloneProduct() {
    // fecha o modal
    this.handleClickModalCloneProduct();

    this.setState({
      loadingCloneProduct: true,
      actionButtonDisabled: true
    });

    (async () => {
      try {
        await this.props.dispatch(cloneProductById(this.props.productData.id));
        this.props.history.push('/producer/product/editproduct/' + this.props.cloneProductById.product.id);

        // add scroll na página novamente
        functions.addScrollPage();
      } catch {
        toast.error('Ops, erro ao clonar o produto');

        this.setState({
          loadingCloneProduct: false,
          actionButtonDisabled: false
        });
      }
    })();
  }

  // ao alterar o campo (convite de afiliados e entrega manual), pega o valor dele e seta no state
  handleChange = (prop: any, event: any) => {
    // incluindo estilo de erro no input, se algo der errado
    if (prop === 'inputInviteAffiliate') {
      this.setState({
        inputInviteAffiliate: event.target.value
      });
      this.onValidation(prop);
    }

    if (prop === 'inputDelivery') {
      this.setState({
        inputDeliveryError: false,
        inputDelivery: event.target.value
      });
    }
  };

  // envia o convite para o afiliado
  handleClickInviteAffiliate() {
    let newState = this.state;
    let validationErrors = {};
    let array = [];

    for (let prop in fieldValidations) {
      array.push(fieldValidations[prop]);
    }

    validationErrors = run(newState, array);

    this.setState({
      validationErrors
    });

    if (Object.keys(validationErrors).length === 0) {
      (async () => {
        try {
          await this.props.dispatch(productInviteAffiliate(this.props.productData.id, this.state.inputInviteAffiliate));

          this.setState({
            inputInviteAffiliate: '',
            numberAffiliates: this.state.numberAffiliates + 1
          });

          this.props.onEditProduct();
          toast.success('Sucesso, afiliado adicionado com êxito');
        } catch (error) {
          toast.error(error);
        }
      })();
    }
  }

  // envia a entrega manual
  handleClickDelivery() {
    const { productData: product } = this.props;
    this.setState({
      inputDeliveryError: false
    });

    (async () => {
      try {
        if (Alumy.isAlumy(product.cnt_partner_cod)) {
          await this.props.dispatch(Alumy.alumyProductDelivery(product.id, this.state.inputDelivery));
        } else {
          await this.props.dispatch(productDelivery(product.id, this.state.inputDelivery));
        }

        this.setState({
          inputDelivery: '',
          inputDeliveryError: false
        });

        toast.success('Sucesso, arquivo entregue com êxito');
      } catch (error: any) {
        if (typeof error === 'string') {
          toast.error(error);
          return;
        }
        toast.error('Ops, erro na entrega manual');
      }
    })();
  }

  // ao clicar no collapse de faturas do produto
  handleClickGetInvoice() {
    if (this.props.productData) {
      if (!this.state.productInvoiceData) {
        (async () => {
          try {
            await this.props.dispatch(listProductInvoice(this.props.productData.id));
            this.setState({ productInvoiceData: this.props.productInvoice });
          } catch {
            toast.error('Ops, erro nos dados da fatura');
            this.setState({ productInvoiceData: 0 });
          }
        })();
      }
    }
  }

  handleClickGetAffiliatesProductStatusSummary() {
    if (this.props.productData) {
      if (!this.state.affiliatesProductStatusSummaryData) {
        (async () => {
          try {
            await this.props.dispatch(getAffiliatesProductStatusSummary(this.props.productData.id));
            this.setState({ affiliatesProductStatusSummaryData: this.props.affiliatesProductStatusSummary });
          } catch {
            toast.error('Ops, erro nos dados dos afiliados');
            this.setState({ affiliatesProductStatusSummaryData: 0 });
          }
        })();
      }
    }
  }

  componentDidUpdate(prevProps: any) {
    const nextProps = this.props;
    if (prevProps.active === false && nextProps.active) {
      if (nextProps.productData.id && nextProps.productData.id !== this.state.idProductHistory) {
        this.setState({
          loading: true,
          inputDeliveryError: false
        });

        (async () => {
          await this.props.dispatch(showProduct(nextProps.productData.id));
          // zerando todas as informações
          this.setState({
            loading: false,

            inputDelivery: this.state.idProductHistory === nextProps.productData.id ? this.state.inputDelivery : '',
            inputDeliveryError: false,

            inputInviteAffiliate: this.state.idProductHistory === nextProps.productData.id ? this.state.inputInviteAffiliate : '',

            statusProduct: nextProps.productData.status,
            productInvoiceData: null,
            affiliatesProductStatusSummaryData: null,

            numberAffiliates: nextProps.productData.affiliates
          });
        })();
      } else {
        this.setState({
          loading: false,
          actionButtonDisabled: false
        });
      }
    }
  }

  // change status product
  handleChangeStatusProduct = () => {
    this.handleClickModalStatusProduct();
  };

  componentWillUnmount() {
    functions.addScrollPage();
  }

  copiedCheckout() {
    chatBotService.activity(Activity.copyCheckoutLink);
  }

  render() {
    if (!this.props.active) return null;
    const productDataReceive = this.props.productData;
    const activatedChildren = this.props.activatedChildren;
    const physicalProductPending = !!productDataReceive && productDataReceive.type === 3 && productDataReceive.moderation_status === 'P';
    const affiliatesProductStatusSummary = this.props.affiliatesProductStatusSummary;
    const approvedAffiliatesAmount = this.getStatusAmountByStatus(affiliatesProductStatusSummary, 'A');
    const disapprovedAffiliatesAmount = this.getStatusAmountByStatus(affiliatesProductStatusSummary, 'R');
    const pendingAffiliatesAmount = this.getStatusAmountByStatus(affiliatesProductStatusSummary, 'P');
    const cantManualDelivery = productDataReceive?.has_children || this.state.statusProduct === 'inactive';

    const labelToggleStatus = this.props.productStatus.isFetching ?
    (
      <span style={{ position: 'relative', top: '3px' }}>
        <CircularProgress size={18} />
      </span>
    ) : PRODUCT_STATUS_LABEL[this.state.statusProduct];

    if (this.state.loading) {
      return (
        <React.Fragment>
          <div className={'my-quickview ' + (this.props.active ? ' -active' : '')}>
            <div className='loading' style={{ height: '100%' }}>
              <Spin tip='Carregando produto ...' />
            </div>
          </div>
          <div className={this.props.active ? 'my-overlay -active' : 'my-overlay'}></div>
        </React.Fragment>
      );
    }

    const dontShowArchiveVariationTootip = productDataReceive.parent_product == 0 || activatedChildren > 2;

    return (
      <React.Fragment>
        <div className={'my-quickview --quickView-product' + (this.props.active ? ' -active' : '')}>
          <div className='my-quickview__head'>
            <Grid container alignItems='center' direction='row' justify='space-between'>
              <div className='my-quickview__title'>Produto: {productDataReceive.id}</div>
              <div className='my-quickview__close' onClick={this.handleCloseQuickView}>
                <MyIcon name='icon-close' />
              </div>
            </Grid>
          </div>

          <div className='my-quickview__container'>
            {this.state.statusProduct !== 'filed' && (
              <Fragment>
                <Grid container justify='space-between' alignItems='center'>
                  <PermissionHide action='myeduzz:meus-produtos:editar'>
                  <Tooltip
                    disableFocusListener={dontShowArchiveVariationTootip}
                    disableHoverListener={dontShowArchiveVariationTootip}
                    disableTouchListener={dontShowArchiveVariationTootip}
                    title={'Ao excluir essa variação todo o Produto será excluído'}
                  >
                    <Button
                      id='quickview-product-delete-button'
                      size='small'
                      onClick={this.handleClickModalStatusProductArchive}
                      style={{ color: !this.state.actionButtonDisabled ? '#596375' : '#ddd', fontSize: 12 }}
                      disabled={this.state.actionButtonDisabled}
                    >
                      {this.state.loadingStatusArchive && this.props.productStatus.isFetching ? (
                        <CircularProgress size={12} style={{ marginRight: 10 }} />
                      ) : (
                        <Icon style={{ fontSize: 12, color: '#596375', marginRight: '0.5rem' }}>archive</Icon>
                      )}
                      Excluir
                    </Button>
                    </Tooltip>
                  </PermissionHide>

                  {!Alumy.isAlumy(productDataReceive.cnt_partner_cod) &&
                    !productDataReceive.has_children &&
                    productDataReceive.type !== 2 && (
                      <PermissionHide action='myeduzz:meus-produtos:editar'>
                        <Button
                        id='quickview-product-copy-button'
                          size='small'
                          onClick={this.handleClickModalCloneProduct}
                          style={{ color: !this.state.actionButtonDisabled ? '#596375' : '#ddd', fontSize: 12 }}
                          disabled={this.state.actionButtonDisabled}
                        >
                          {this.state.loadingCloneProduct && this.props.cloneProductById.isFetching ? (
                            <CircularProgress size={12} style={{ marginRight: '0.5rem' }} />
                          ) : (
                            <Icon style={{ fontSize: 12, color: '#596375', marginRight: '0.5rem' }}>content_copy</Icon>
                          )}
                          Copiar
                        </Button>
                      </PermissionHide>
                    )}

                  {productDataReceive.has_children && (productDataReceive.type === constants.INFO || productDataReceive.type === constants.PHYSICAL || productDataReceive.type === constants.TICKET) && (
                    <EditButton id={productDataReceive.id} parentId={productDataReceive.parent_product} onClick={functions.addScrollPage} disabled={this.state.actionButtonDisabled} />
                  )}

                  {!productDataReceive.has_children &&
                    (productDataReceive.type === constants.INFO || productDataReceive.type === constants.PHYSICAL || productDataReceive.type === constants.TICKET || productDataReceive.type === constants.JOBZZ) && (
                      <EditButton id={productDataReceive.id} parentId={productDataReceive.parent_product} onClick={functions.addScrollPage} disabled={this.state.actionButtonDisabled} />
                    )}
                </Grid>
              </Fragment>
            )}

            <div className='m16' />
            {!!productDataReceive.todo && (
              <>
                <Grid item>
                  <Alert severity="warning">
                    <AlertTitle>Atualize seu modelo de comissão para porcentagem</AlertTitle>
                    <p>Você ainda tem comissões por valor cadastradas em seus produtos!</p>
                    <p>Atualize suas comissões para o modelo de porcentagem.</p>
                  </Alert>
                </Grid>
                <div className='m16' />
              </>
            )}

            <Grid container>
              <Grid
                item
                className='product__image'
                xs={4}
                sm={4}
                style={{
                  backgroundImage: `url(${productDataReceive.image ? productDataReceive.image : ''})`
                }}
              />

              <Grid item className='product__info' xs={8} sm={8}>
                <div className='product__name' title={productDataReceive.title ? productDataReceive.title : 'Produto desconhecido'}>
                  <Truncate count={40} final={'...'}>
                    {productDataReceive.title ? productDataReceive.title : 'Produto desconhecido'}
                  </Truncate>
                </div>

                <div className='m4' />
                <div className='product__status'>
                  {/* {!productDataReceive.has_children && ( */}
                  {this.state.statusProduct !== 'draft' ?
                    <FormControlLabel
                    label={labelToggleStatus}
                    control={
                      <Switch
                        color='default'
                        defaultChecked={this.state.statusProduct === 'active' ? true : false}
                        checked={this.state.statusProduct === 'active' ? true : false}
                        disabled={this.state.statusProduct === 'filed' || this.props.productStatus.isFetching ? true : false}
                        onChange={this.handleChangeStatusProduct}
                      />
                    }
                  />
                  : <div className='draft__label'>
                    <DraftLabel />
                  </div>
                  }
                </div>
              </Grid>
            </Grid>

            <div className='m24' />
            {!productDataReceive.has_children && (
              <Grid container>
                <Grid item className='product__table' xs={12} sm={12}>
                  <div className='product_row'>
                    <div className='row_el'>
                      <div className='el_title'>Ganhos</div>
                      <span className='fw600 clgreen'>
                        <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
                          <ColoredFormattedNumber value={productDataReceive.total_gains} format={productDataReceive.currency.code} />
                        </PermissionHide>
                        <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                          <em>oculto</em>
                        </PermissionHide>
                      </span>
                    </div>

                    <div className='row_el txtCenter'>
                      <div className='el_title'>Afiliados</div>
                      <span>{this.state.numberAffiliates}</span>
                    </div>

                    <div className='row_el txtCenter'>
                      <div className='el_title'>Funil Infinito</div>
                      <span className={productDataReceive.infinity_funnel ? 'fw600 clgreen' : ''}>
                        {' '}
                        {productDataReceive.infinity_funnel ? 'Ativado' : 'Desativado'}{' '}
                      </span>
                    </div>
                  </div>

                  <div className='m24' />

                  <div className='product_row --row-all-padding'>
                    <div className='row_el'>
                      <div className='el_title fw600 clgreen'>
                        {productDataReceive.charge_type === 'A' && (
                          <span>
                            <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
                              <FormattedNumber value={productDataReceive.recurring_value} format='BRL' /> recorrente
                            </PermissionHide>
                            <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                              <em>oculto</em>
                            </PermissionHide>
                          </span>
                        )}
                        {productDataReceive.charge_type === 'N' && (
                          <Fragment>
                            <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
                              <FormattedNumber value={productDataReceive.price} format='BRL' />
                            </PermissionHide>
                            <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                              <em>oculto</em>
                            </PermissionHide>
                          </Fragment>
                        )}
                        {productDataReceive.charge_type === 'G' && (
                          <span>
                            <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
                              Grátis
                            </PermissionHide>
                            <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                              <em>oculto</em>
                            </PermissionHide>
                          </span>
                        )}
                        {(!productDataReceive.charge_type || productDataReceive.charge_type === '' || productDataReceive.charge_type === ' ') && (
                          <Fragment>
                            <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
                              <FormattedNumber value={0} format='BRL' />
                            </PermissionHide>
                            <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                              <em>oculto</em>
                            </PermissionHide>
                          </Fragment>
                        )}
                      </div>

                      {/* comissão */}
                      {productDataReceive.charge_type === 'A' && (
                        <span>
                          <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
                            <CalculateCommissionAffiliate
                              price={productDataReceive.recurring_value}
                              commissionType={productDataReceive.recurring_comission_type}
                              commissionValue={productDataReceive.recurring_comission_value}
                            />
                          </PermissionHide>
                          <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                            <em>oculto</em>
                          </PermissionHide>{' '}
                          de Com. recorrente
                        </span>
                      )}
                      {productDataReceive.charge_type === 'N' && (
                        <span>
                          <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
                            <CalculateCommissionAffiliate
                              price={productDataReceive.price ? productDataReceive.price : 0}
                              commissionType={productDataReceive.comission_type}
                              commissionValue={productDataReceive.comission_value}
                            />
                          </PermissionHide>
                          <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                            <em>oculto</em>
                          </PermissionHide>{' '}
                          de Comissão
                        </span>
                      )}
                      {productDataReceive.charge_type === 'G' && (
                        <span>
                          <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
                            <CalculateCommissionAffiliate
                              price={productDataReceive.price}
                              commissionType={productDataReceive.comission_type}
                              commissionValue={productDataReceive.comission_value}
                            />
                          </PermissionHide>
                          <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                            <em>oculto</em>
                          </PermissionHide>{' '}
                          de Comissão
                        </span>
                      )}
                      {(!productDataReceive.charge_type || productDataReceive.charge_type === ' ' || productDataReceive.charge_type === '') && (
                        <span>
                          <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
                            <CalculateCommissionAffiliate price={0} commissionValue={0} />
                          </PermissionHide>
                          <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                            <em>oculto</em>
                          </PermissionHide>{' '}
                          de Comissão
                        </span>
                      )}
                    </div>

                    <div className='row_el'>
                      <div className='el_title'>{productDataReceive.rpc_affiliate ? productDataReceive.rpc_affiliate : 0}</div>
                      <span>RPC/A</span>
                    </div>

                    <div className='row_el'>
                      <div className='el_title'>{productDataReceive.rpc_producer ? productDataReceive.rpc_producer : 0}</div>
                      <span>RPC/P</span>
                    </div>
                  </div>
                </Grid>
              </Grid>
            )}
            <div className='m24' />

            <QuickActions
              productDataReceive={productDataReceive}
              statusProduct={this.state.statusProduct}
              physicalProductPending={physicalProductPending}
              copiedCheckout={() => this.copiedCheckout()}
              handleChange={this.handleChange}
              inputInviteAffiliate={this.state.inputInviteAffiliate}
              productData={this.props.productData}
              isValid={this.isValid}
              handleClickInviteAffiliate={() => this.handleClickInviteAffiliate()}
              productInviteAffiliate={this.props.productInviteAffiliate}
              errorFor={this.errorFor}
              handleClickGetAffiliatesProductStatusSummary={() => this.handleClickGetAffiliatesProductStatusSummary()}
              affiliatesProductStatusSummary={affiliatesProductStatusSummary}
              approvedAffiliatesAmount={approvedAffiliatesAmount}
              disapprovedAffiliatesAmount={disapprovedAffiliatesAmount}
              pendingAffiliatesAmount={pendingAffiliatesAmount}
              cantManualDelivery={cantManualDelivery}
              inputDeliveryError={this.state.inputDeliveryError}
              inputDelivery={this.state.inputDelivery}
              handleClickDelivery={() => this.handleClickDelivery()}
              productDelivery={this.props.productDelivery}
              handleClickGetInvoice={() => this.handleClickGetInvoice()}
              productInvoice={this.props.productInvoice}
            />
          </div>
        </div>

        <div className={this.props.active ? 'my-overlay -active' : 'my-overlay'} onClick={this.handleCloseQuickView}></div>

        {/* modal para ativar ou desativar o produto */}
        <ModalActions
          open={this.state.modalStatusProduct}
          onClose={this.onCancelModal}
          onOk={this.onConfirmModal}
          title={`Deseja realmente ${this.state.statusProduct === 'active' ? 'inativar' : 'ativar'} este produto? `}
          buttonOk={this.state.statusProduct === 'active' ? 'Inativar' : 'Ativar'}
        >
          {
            (this.state.statusProduct === 'active' && productDataReceive.has_children)
              ? 'Atenção, enquanto o produto pai estiver inativo todas suas variações também ficarão inativas no checkout.'
              : ''
          }
        </ModalActions>

        {/* modal para arquivar o produto */}
        <ModalActions
          open={this.state.modalStatusProductArchive}
          onClose={this.onCancelModalArchive}
          onOk={this.onConfirmModalArchive}
          title='Deseja realmente excluir este produto?'
          buttonOk={'Excluir'}
          buttonOkColor={'#dc3f53'}
        >
          <p>{`Atenção, esta operação é irreversível${this.props.productData.has_children ? ' e automaticamente todas variações serão excluídas.' : '.'}` } </p>
        </ModalActions>

        {/* modal para clonar o produto */}
        <ModalActions
          open={this.state.modalCloneProduct}
          onClose={this.onCancelModalCloneProduct}
          onOk={this.onConfirmModalCloneProduct}
          title={'Deseja realmente duplicar este produto?'}
          buttonOk={'Duplicar'}
        >
          <p>Obs: você será redirecionado para a tela de edição.</p>
        </ModalActions>
      </React.Fragment>
    );
  }
  private getStatusAmountByStatus(affiliatesProductStatusSummary: any, status: string): number {
    let status_amount =
      Array.isArray(affiliatesProductStatusSummary) && affiliatesProductStatusSummary.find((x: any) => x.status == status)?.status_amount;

    if (!status_amount) {
      status_amount = 0;
    }

    return status_amount;
  }
}
function mapStateToProps(state: any) {
  return {
    productInvoice: state.orbita.Product.productInvoice,
    affiliatesProductStatusSummary: state.orbita.Product.affiliatesProductStatusSummary,
    productStatus: state.orbita.Product.productStatus,
    productInviteAffiliate: state.orbita.Product.productInviteAffiliate,
    productDelivery: state.orbita.Product.productDelivery,
    cloneProductById: state.orbita.Product.cloneProductById,
    vitrineData: state.orbita.Showcase.showProduct && state.orbita.Showcase.showProduct.product,
    user: state.orbita.User.user,
  };
}
export default withRouter(connect(mapStateToProps)(QuickView));
